import { EmptyState, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import {
  convoyIdsState,
  convoysPageState,
  convoysState,
  loadingConvoysState,
  selectedConvoyIdState,
} from '../../storage/convoys';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { VirtualizedPaginatedList } from '../shared/VirtualizedPaginatedList';
import ConvoyFilters from './ConvoyFilters';
import ConvoyItem from './ConvoyItem';

export function ConvoyList() {
  const { theme } = useStyles();
  const convoyIds = useRecoilValue(convoyIdsState);
  const setSelectedConvoyId = useSetRecoilState(selectedConvoyIdState);
  const resetSelectedConvoyId = useResetRecoilState(selectedConvoyIdState);
  const loadingConvoys = useRecoilValue(loadingConvoysState);
  const paginatedConvoys = useRecoilValue(convoysState);
  const setConvoysPage = useSetRecoilState(convoysPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedConvoyId();
    };
  });

  const onNewConvoy = () => {
    setSelectedConvoyId('');
  };

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      {!convoyIds && !loadingConvoys && <EmptyState title="Todavía no creas ningun convoy" />}
      {!convoyIds && loadingConvoys && <Loading />}
      {convoyIds && (
        <>
          <ConvoyFilters />
          <VirtualizedPaginatedList
            ids={convoyIds}
            loading={loadingConvoys}
            onNextPage={setConvoysPage}
            paginatedResponse={paginatedConvoys}
            itemComponent={ConvoyItem}
          />
          {!convoyIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
      {(convoyIds || !loadingConvoys) && (
        <StyledButton
          size="compact"
          shape="square"
          onClick={onNewConvoy}
          startEnhancer={<MaterialIcon name={'add'} />}
          kind="tertiary"
        >
          Nuevo convoy
        </StyledButton>
      )}
    </FloatingCardContent>
  );
}
